import React, { useState } from 'react';
import * as FollowsListAPI from '../../../api/FollowsListAPI';

/**
 * Follows list popup component
 * @param followsListsParam the follows list to use
 * @param setShow method to set whether or not to show the popup
 * @param orgID the current org's ID
 * @param articleID
 * @param setShowStatusPopup what status to show
 * @param setShowStatus the setter for the boolean to actually show the popup
 */
export const NewFollowsListPopup = ({
	followsListsParam,
	setShow,
	orgID,
	articleID,
	setShowStatusPopup,
	setShowStatus,
}) => {
	const [followsLists, setFollowsLists] = useState(followsListsParam);

	const addOrRemoveFollow = (list) => {
		if (orgID) addOrRemoveFollowOrg(list);
		if (articleID) addOrRemoveFollowArticle(list);
	};

	/**
	 * Adds or removes the current org from the chosen list, depending on if it's currently followed or not
	 * @param list
	 */
	const addOrRemoveFollowOrg = (list) => {
		let isAdd = false;
		if (list.organization_ids.includes(orgID)) {
			list.organization_ids.splice(
				list.organization_ids.indexOf(orgID),
				1
			);
		} else {
			isAdd = true;
			list.organization_ids.push(orgID);
		}
		setFollowsLists(followsLists);
		FollowsListAPI.editList(list.id, list).then((r) => {
			if (isAdd) {
				setShowStatusPopup({
					show: true,
					text:
						'Successfully added this organization to ' + list.name,
					type: 'success',
				});
			} else {
				setShowStatusPopup({
					show: true,
					text:
						'Successfully removed this organization from ' +
						list.name,
					type: 'success',
				});
			}
			setShowStatus(true);
		});
	};

	/**
	 * Adds or removes the current article from the chosen list, depending on if it's currently followed or not
	 * @param list
	 */
	const addOrRemoveFollowArticle = (list) => {
		let isAdd = false;
		if (list.article_ids.includes(articleID)) {
			list.article_ids.splice(list.article_ids.indexOf(articleID), 1);
		} else {
			isAdd = true;
			list.article_ids.push(articleID);
		}
		setFollowsLists(followsLists);
		FollowsListAPI.editList(list.id, list).then((r) => {
			if (isAdd) {
				setShowStatusPopup({
					show: true,
					text: 'Successfully added this article to ' + list.name,
					type: 'success',
				});
			} else {
				setShowStatusPopup({
					show: true,
					text: 'Successfully removed this article from ' + list.name,
					type: 'success',
				});
			}
			setShowStatus(true);
		});
	};

	const createListAndFollow = () => {
		if (orgID) createListAndFollowOrg();
		if (articleID) createListAndFollowArticle();
	};

	/**
	 * Creates a list and follow the organization
	 */
	const createListAndFollowOrg = () => {
		try {
			let listName = document.getElementById('new-list-input-box').value;
			let payload = { name: listName };

			FollowsListAPI.createList(payload).then((response) => {
				let newID = response.data.id;
				let payload = {
					name: listName,
					id: newID,
					organization_ids: [orgID],
				};
				FollowsListAPI.editList(newID, payload).then((r) => {
					r.data['organization_ids'] = [orgID];
					followsLists.push(r.data);
					setFollowsLists(followsLists);
					setShowStatusPopup({
						show: true,
						text: 'Successfully created ' + listName,
						type: 'success',
					});
					document.getElementById('new-list-input-box').value = '';
				});
			});
			setShowStatus(true);
		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Creates a list and follows the article
	 */
	const createListAndFollowArticle = () => {
		try {
			let listName = document.getElementById('new-list-input-box').value;
			let payload = { name: listName };

			FollowsListAPI.createList(payload).then((response) => {
				let newID = response.data.id;
				let payload = {
					name: listName,
					id: newID,
					article_ids: [articleID],
				};
				FollowsListAPI.editList(newID, payload).then((r) => {
					r.data['article_ids'] = [articleID];
					followsLists.push(r.data);
					setFollowsLists(followsLists);
					setShowStatusPopup({
						show: true,
						text: 'Successfully created ' + listName,
						type: 'success',
					});
					document.getElementById('new-list-input-box').value = '';
				});
			});
			setShowStatus(true);
		} catch (e) {
			console.error(e);
		}
	};

	const isAlreadyFollowed = (list) => {
		if (orgID) return list.organization_ids.includes(orgID);
		if (articleID) return list.article_ids.includes(articleID);
	};

	return (
		<div className="new-follows-list-popup">
			<div className="background-filter" onClick={() => setShow(false)} />
			<div className="card-inner">
				<h1 className="add-item-title">Add Item To</h1>
				<i
					id="new-list-close-button"
					className="fas fa-times"
					onClick={() => setShow(false)}
				/>

				{followsLists?.map((list) => {
					return (
						<h5
							className="name-holder"
							onClick={() => addOrRemoveFollow(list)}
							key={list.id}
						>
							{isAlreadyFollowed(list) ? (
								<i className="fa fa-minus-circle" />
							) : (
								<i className="fa fa-plus-circle" />
							)}
							<p className="list-name">{list.name}</p>
						</h5>
					);
				})}

				<h6 className="add-to-new-list-subtitle">Add to new list</h6>
				<input
					id="new-list-input-box"
					className="body-font-important"
					type="text"
					placeholder="Insert list name"
					autoComplete="false"
				/>
				<div className="save-button-wrapper">
					<div
						className="primary-button"
						onClick={() => createListAndFollow()}
					>
						<p>Save</p>
					</div>
				</div>
			</div>
		</div>
	);
};
